export {
  type OrgChatApiAttachment,
  type SelectedContextWorkspaceSource,
  collectSelectedContextWorkspaceSources,
  type OrgChatSendPayload,
  sanitizeOrgChatSendPayloadForTransport,
  USER_SKILL_CHIP_UPLOAD_ID_PREFIX,
  CUSTOM_REFERENCE_UPLOAD_ID_PREFIX,
  parseCustomReferenceUploadId,
  isCustomReferenceAttachment,
  customReferenceFieldsFromUploadId,
  applyCustomReferenceFields,
  COMPOSER_UPLOAD_UUID_RE,
  isComposerUploadChip,
  isSelectedImageChip,
  isCustomReferenceChip,
  isSelectedWorkspaceFileChip,
} from './payload/org-chat-api-attachment';
export {
  reconcileComposerUploadAttachments,
  type PresetUploadCategory,
  type StyleReferenceType,
  getPresetUploadReferenceCategory,
  partitionStyleReferenceUploads,
  type AttachmentIdentityInput,
} from './payload/reconcile-composer-upload-attachments';
export {
  attachmentIdentityKeys,
  dedupeAttachmentsByIdentity,
  includeSemanticDocumentAttachments,
  buildPaletteInstruction,
  type SelectedUserSkillPayload,
  userSkillChipUploadId,
  isUserSkillVfsPath,
  extractSelectedUserSkillsFromFileChips,
  mergeSelectedUserSkills,
  hasItems,
  WORKSPACE_NATIVE_ARTIFACT_EXTENSIONS,
  isWorkspaceNativeArtifactReference,
  uniqueStrings,
  getStablePreviewUrl,
  clientInputSequence,
  createOrgChatClientInputId,
} from './payload/attachment-identity-keys';
export {
  buildBasePayload,
  buildAttachmentFields,
} from './payload/build-base-payload';
export {
  buildPresetFields,
  mergeReferencePayloadFields,
} from './payload/build-preset-fields';
